"use client";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { useTranslation } from "@/hooks/useLanguage";

export const Cta = () => {
  const { t } = useTranslation();
  return (
    <section id="cta" className="bg-muted/50 py-16 my-24 sm:my-32">
      <div className="container lg:grid lg:grid-cols-2 place-items-center">
        <div className="lg:col-start-1">
          <h2 className="text-3xl md:text-4xl font-bold ">
            {t("cta.title_1")}{" "}
            <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
              {" "}
              {t("cta.title_1_span")}{" "}
            </span>
            {t("cta.title_2")}
          </h2>
          <p className="text-muted-foreground text-xl mt-4 mb-8 lg:mb-0">
            {t("cta.description")}
          </p>
        </div>

        <div className="space-y-4 lg:col-start-2">
          <Button asChild className="w-full md:me-4 md:w-auto">
            <Link href="/register">{t("cta.button_1")}</Link>
          </Button>
          <Button asChild variant="outline" className="w-full md:w-auto">
            <Link href="#features">{t("common.explore_features")}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
